import * as React from 'react';
import { colors } from './stylesheet';

/** Wraps content in an inset */
export function Inset(props: { children: any }) {
	return (
		<div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
			{props.children}
		</div>
	);
}

/** Divider (free space) to use between different areas */
export function Divider(props: {
	large?: boolean,
	size?: number,
	dashed?: boolean,
	dashColor?: string
}) {
	const height = (props.size && `${props.size}px`) || (props.large && '30px') || '15px';
	const styleSet: React.CSSProperties = {
		border: "none",
		height,
		borderTop: props.dashed ? `1px dotted ${props.dashColor || "#D0D0D0"}` : "none",
	};

	return <div style={styleSet} />;
}

/** Divider (horizontal line) to use between different areas */
export function SectionDivider(props: { style?: React.CSSProperties }) {
	return (
		<div style={{ background: colors.faded, width: '100%', margin: '5px 0px 5px 0px', height: '1px', ...props.style || {} }} />
	);
}
